/**
 * @generated SignedSource<<837fd45cd43253d2a912c310f5626bab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JourneyContext_viewer$data = {
  readonly hasAccessToCopilot: boolean;
  readonly integrations: {
    readonly google: {
      readonly id: string;
    } | null;
  };
  readonly questionAnswers: any | null;
  readonly signupConsumedInvite: {
    readonly id: string;
    readonly path: string | null;
  } | null;
  readonly signupConsumedStreamInviteStream: {
    readonly url: string | null;
  } | null;
  readonly signupMeetingRecording: {
    readonly id: string;
  } | null;
  readonly signupMeetingStreams: ReadonlyArray<{
    readonly createdAt: string | null;
    readonly id: string;
    readonly nextEventWithContent: {
      readonly url: string;
    } | null;
    readonly url: string | null;
  }> | null;
  readonly signupOneononeStreams: ReadonlyArray<{
    readonly url: string | null;
  }> | null;
  readonly signupPersonalStreams: ReadonlyArray<{
    readonly url: string | null;
  }> | null;
  readonly signupTemplate: {
    readonly creator: {
      readonly isViewer: boolean;
    } | null;
    readonly id: string;
    readonly url: string;
  } | null;
  readonly signupTemplateStream: {
    readonly id: string;
    readonly url: string | null;
  } | null;
  readonly " $fragmentType": "JourneyContext_viewer";
};
export type JourneyContext_viewer$key = {
  readonly " $data"?: JourneyContext_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"JourneyContext_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./JourneyContextViewerQuery.graphql')
    }
  },
  "name": "JourneyContext_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionAnswers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Invite",
      "kind": "LinkedField",
      "name": "signupConsumedInvite",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "signupConsumedStreamInviteStream",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "signupMeetingStreams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextEventWithContent",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "signupOneononeStreams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "signupPersonalStreams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteTemplateNode",
      "kind": "LinkedField",
      "name": "signupTemplate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isViewer",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "signupTemplateStream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "signupMeetingRecording",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GoogleUserNode",
          "kind": "LinkedField",
          "name": "google",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7eebda71f67ccc6d9d94f0db8ff71ae2";

export default node;
